import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { WalletUserDetailResponse } from '@/repositories/generated';

const response: WalletUserDetailResponse = {
  externalUserId: 'test_user_001',
  firstName: '太郎',
  firstNameKana: 'タロウ',
  lastName: '山田',
  lastNameKana: 'ヤマダ',
  lockStatus: 'AVAILABLE',
  remarks: '備考',
  status: 'AVAILABLE',
  updatedAt: '2021-01-01T00:00:00.000+09:00',
  walletServiceId: '001',
  displayName: true,
  displayNameKana: true,
  walletUserDetailBasicInfo: {
    agreedPrivacyPolicyDateTime: '2021-01-01T00:00:00.000+09:00',
    agreedPrivacyPolicyVersion: '6.0',
    agreedTermsDateTime: '2021-01-01T00:00:00.000+09:00',
    agreedTermsVersion: '1.0',
    birthday: '1998-09-12',
    createdAt: '2021-01-01T00:00:00.000+09:00',
    deviceModel: 'iPhone 12 Pro Max',
    deviceOsType: 'iOS',
    deviceOsVersion: '14.4',
    email: 'test@example.com',
    issuerId: '101',
    issuerName: 'テストイシュア',
    phoneNumber: '09011112222',
    sex: 'MALE',
    stoppedAt: '',
    userType: 'PRINCIPAL',
    withdrawalAt: '',
    withdrawalCode: '',
    displayBirthday: true,
    displayGender: true,
  },
  walletUserDetailNoticeInfo: {
    balanceNotice: true,
    chargeNotice: true,
    loginLockNotice: true,
    paymentNotice: true,
  },
  walletUserDetailPaymentMethodInfo: {
    walletUserCreditCardInfos: [
      {
        affiliatedCardCode: '101',
        creditCardBrand: 'VISA',
        creditCardHolder: 'Yamada Taro',
        creditCardMonth: 12,
        creditCardNumber: '1234567890123456',
        creditCardYear: 25,
        creditPaymentMethodId: 546,
      },
    ],
    walletUserDirectBankInfos: [
      {
        accountStatus: true,
        bankPaymentMethodId: 123,
        bankAccountNumber: '1111111',
        bankAccountType: '普通',
        bankBranchCode: '111',
        bankCode: '111',
        bankName: 'テスト銀行',
      },
      {
        accountStatus: false,
        bankPaymentMethodId: 456,
        bankAccountNumber: '2222222',
        bankAccountType: '普通',
        bankBranchCode: '222',
        bankCode: '222',
        bankName: 'テスト銀行',
      },
    ],
    walletUserPrepaidInfos: [
      {
        balanceTotal: 100000,
        bonusValue: 10000,
        fundsTransferValue: 10000,
        giftDetailName: undefined,
        giftName: undefined,
        lastCompletedAt: '2021-01-01T00:00:00.000+09:00',
        pointTotal: 10000,
        prepaidPaymentMethodId: 123,
        prepaidType: 'GIFT',
        prepaidValue: 10000,
        valueTotal: 100000,
        walletServiceId: '001',
        walletServiceName: 'モックWS1',
        basicPoint: 10000,
        bonusPoint: 1000,
        expiredDateUpdateAvailableFlg: true,
      },
    ],
  },
  walletUserDetailTransactionLimitInfo: {
    maxChargeAmount: 10000,
    maxChargeAmountPerDay: 200000,
    maxChargeAmountPerMonth: 3000000,
    maxSettlementAmount: 400000,
    maxSettlementAmountPerDay: 5000000,
    maxSettlementAmountPerMonth: 60000000,
  },
  walletUserId: '001',
  isLogin: true,
  pointRatio: 0.5,
};

export const walletUserDetail = http.get(
  createMockEndpoint('/wallet_user/:id'),
  async ({ params }) => {
    switch (params.id) {
      case '4':
        // チャージ無効
        return HttpResponse.json({
          ...response,
          ...{
            walletUserDetailTransactionLimitInfo: {
              maxSettlementAmount: 400000,
              maxSettlementAmountPerDay: 5000000,
              maxSettlementAmountPerMonth: 60000000,
            },
          },
        }, { status: 200 });
      case '5':
        // 物理プリペイドカード番号あり
        return HttpResponse.json({
          ...response,
          ...{
            walletUserDetailPaymentMethodInfo: {
              ...response.walletUserDetailPaymentMethodInfo.walletUserCreditCardInfos,
              ...response.walletUserDetailPaymentMethodInfo.walletUserDirectBankInfos,
              walletUserPrepaidInfos: [
                {
                  ...response.walletUserDetailPaymentMethodInfo.walletUserDirectBankInfos[0],
                  physicalPrepaidCardNumber: '0000000000000001',
                },
              ],
            },
          },
        }, { status: 200 });
      case '6':
        // 商品券プリペイドなので残高調整できない
        return HttpResponse.json({ ...response,
          ...{
            walletUserDetailPaymentMethodInfo: {
              walletUserPrepaidInfos: [
                {
                  ...response.walletUserDetailPaymentMethodInfo.walletUserPrepaidInfos[0],
                  giftName: '〇〇市プレミアム商品券1',
                  giftDetailName: '【赤券】（大型店・一般店で利用可能）',
                },
              ],
            },
          } }, { status: 200 });
      case '7':
        // 決済手段なし
        return HttpResponse.json({
          ...response,
          ...{
            walletUserDetailPaymentMethodInfo: {
              walletUserPrepaidInfos: [],
              walletUserDirectBankInfos: [],
              walletUserCreditCardInfos: [],
            },
          },
        }, { status: 200 });
      default:
        break;
    }

    await delay(500);
    return HttpResponse.json(response, { status: 200 });
  },
);
